import type { GetServerSideProps } from 'next';
import Cookies from '@/components/Cookies';
import { getCurrentProgrammeId } from '@/utils/programme';
import { serverSideTranslations } from '@/utils/serverSideTranslations';
import { sharedTranslationNamespaces } from '@/utils/constants';
import { getCurrentUser } from '@/utils/user';
import { getWalletData } from '@/services/getWalletData';
import { buildDataLayerInfo } from '@/utils/dataLayer';

export const getServerSideProps: GetServerSideProps = async context => {
  const programmeId = getCurrentProgrammeId(context.req);

  const user = await getCurrentUser(context.req, context.res, {
    isLoggedInAction: false,
  });
  if (!user) {
    return {
      props: {
        programmeId,
        dataLayerInfo: buildDataLayerInfo({ programmeId }),
        ...(await serverSideTranslations(context.locale ?? 'en', [
          ...sharedTranslationNamespaces,
          `${programmeId}/cookies`,
        ])),
      },
    };
  }
  const { balance, totalAviosBalance } = await getWalletData(programmeId, user);

  return {
    props: {
      programmeId,
      dataLayerInfo: buildDataLayerInfo({ user, programmeId, balance }),
      ...(await serverSideTranslations(context.locale ?? 'en', [
        ...sharedTranslationNamespaces,
        `${programmeId}/cookies`,
      ])),
      singleAviosBalance: totalAviosBalance,
    },
  };
};

export default Cookies;
